const messages = {
  title: "Árlisták és termékbrosúrák",
  title_media: "Árlisták és termékbrosúrák",
  description:
    "Töltse le a legújabb brosúrákat és szórólapokat Bridgestone és Firestone gumiabroncsairól személygépkocsikhoz, SUV-khoz és kishaszongépjárművekhez.",
  short_description:
    "Itt találhat anyagokat közösségi médiához, üzleti TV-hez és egyebekhez.",
  mediaCategories: {
    products: "Termékek",
    brand_and_solutions: "Márka és megoldások",
    season_and_promotions: "Szezon és promóciók",
    format: "Formátum",
    cars_and_vans: "Személyautó, SUV, haszonjármű",
    truck_and_buses: "Teherautó és busz",
    motorcycle: "Motorkerékpár",
    agriculture: "Mezőgazdaság",
    construction_machinery: "Építőipari gépek",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Anyagok",
    brochures: "Termékbrosúrák",
    price_list: "Árlisták",
    materials: "Anyagok",
    video_in_store: "Videó felirattal",
    video_online: "Videó felirat nélkül",
    video: "Videó",
    banner_website: "Banner",
    banner_social_media: "Közösségi média",
    logos: "Logók",
    summer: "Nyár",
    winter: "Tél",
    all_season: "Négy évszak",
    promotions: "Promóciók",
    price: "Pricat",
  },
  mediasPage: {
    title: "MÉDIATÁR",
    description:
      "Üdvözöljük a Bridgestone és Firestone   \n" +
      "termékeknek szentelt média szekcióban.  \n <br> <br>" +
      "Termékvizuálokat,   \n" +
      "logókat, valamint széles választékot   \n" +
      "bannerekről, videókról és digitális anyagokról   \n" +
      "talál, amelyeket weboldalán vagy a   \n" +
      "közösségi médiában használhat.  ",
    bDrive: {
      title: "Termékfotók",
      description:
        "Az aktuális képek   \n" +
        "letölthetők   \n" +
        "B-\n" +
        "DRIVE portálunkról.  ",
    },
  },
  buttons: {
    media: "FELFEDEZÉS",
  },
  searchMedia: "Adjon meg kulcsszót",
  searchResults: "Keresési eredmények",
};

export default {
  messages,
};
